/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ProductVariant } from '@msdyn365-commerce/retail-proxy';

/**
 * This data action is for storing and syncing data between desktop and mobile view for quick order items set by user
 * EveQuickOrderItems Input Action
 */
export class EveQuickOrderItemsInput implements Msdyn365.IActionInput {
    constructor() {}
    public getCacheKey = () => `EVE-QUICK-ORDER-ITEMS`;
    public getCacheObjectType = () => 'EVE-QUICK-ORDER-ITEMS';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IEveQuickOrderItemsData {
    isInit?: boolean;
    items: {
        itemNumber: string;
        quantity: number;
        selectedVariantID?: string;
        selectedVariant?: ProductVariant;
        discount?: { [key in 'minQuantity' | 'discountValue']: string }[];
        variants?: ProductVariant[];
        description?: { [key in 'name' | 'text']?: string };
    }[];
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new EveQuickOrderItemsInput();
};

async function action(input: EveQuickOrderItemsInput, ctx: Msdyn365.IActionContext): Promise<IEveQuickOrderItemsData> {
    return { items: new Array<IEveQuickOrderItemsData['items'][0]>(9).fill({ itemNumber: '', quantity: 0 }), isInit: true };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IEveQuickOrderItemsData>>action,
    id: 'EveQuickOrderItems',
    input: createInput
});
